import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { Dropdown, IconButton } from "cprime-foundational-components";
import Button from "../../Components/Common/CprimeButton";
import Typography from "../../Components/Common/CprimeText";
import CloseIcon from "@mui/icons-material/Close";
import * as styles from "./CloneRoleModel.module.scss";

interface CloneRoleModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: any;
  roleList: any;
  selectedRoles: any;
  setSelectedRoles: any;
}

const CloneRoleModal: React.FC<CloneRoleModalProps> = ({
  open,
  onClose,
  onConfirm,
  roleList,
  selectedRoles,
  setSelectedRoles,
}) => {
  const scssClass = styles as any;
  const handleDropdownChange = (selected: any) => {
    setSelectedRoles(selected);
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle className={scssClass.cloneModalHeader}>
        Clone Role
        <IconButton
          aria-label="close"
          onClick={onClose}
          name="Close"
          sx={{ position: "absolute", right: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div>
          <p className={scssClass.cloneModalSubHeading}>
            Select Role you want to clone, Role name will need to edited to
            activate
          </p>

          <div>
            <Typography className={scssClass.label}>Role</Typography>
            <Dropdown
              placeholder="Select"
              optionsTextLimit={200}
              fullWidth
              style={{ width: "100%" }}
              //type={DropdownType.MultiSelect}
              options={roleList}
              selectedOptions={selectedRoles}
              disabled={false}
              onChange={(value: any) => handleDropdownChange(value)}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions className={scssClass.roleDialogAction}>
        <Stack direction="row" gap={2} mb={2} mr={2}>
          <Button variant="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={selectedRoles.length === 0}
          >
            Clone
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default CloneRoleModal;
